<template>
  <div class="container center w100 relative-container">
    <div class="padded">
      <div>
        <wrap-container class="cascade w50">
          <form-validator>
            <wrap-container>
              <p
                id="titulo"
                class="titulo p32 medium oscuro"
                v-safe-html="config.pasos.renaperConsultar.titulo"
              />
              <p
                id="subtitulo"
                class="te-pedimos"
                v-safe-html="config.pasos.renaperConsultar.subtitulo"
              />
              <wrap-container
                class="images-dni mobile container grid-container grid-container--6-6"
              >
                <img
                  class="col1"
                  src="@/assets/img/1x/frente-dni-nuevo.png"
                  alt="Frente DNI Nuevo"
                />
                <img
                  class="col2"
                  src="@/assets/img/1x/frente-dni-viejo.png"
                  alt="Frente DNI Viejo"
                />
              </wrap-container>
            </wrap-container>
            <wrap-container>
              <dni-tramite-input
                label="Número de trámite"
                hint="Ej: 00000010532"
                v-model="model.expediente"
                :required="true"
                maxlength="11"
                quantumObfuscate
              />
            </wrap-container>
            <div class="sn-mobile">
              <img
                width="212"
                alt="SID - Sistema de Identidad Digital"
                src="@/assets/img/1x/sid.png"
              />
              <step-navigator
                v-model="model"
                :store-action="doNext"
                :disabled="!canContinue"
                router-push
              />
            </div>
          </form-validator>
        </wrap-container>
        <wrap-container class="cascade w50">
          <wrap-container class="images-dni">
            <img
              src="@/assets/img/1x/frente-dni-nuevo.png"
              alt="Frente DNI Nuevo"
            />
            <img
              src="@/assets/img/1x/frente-dni-viejo.png"
              alt="Frente DNI Viejo"
            />
          </wrap-container>
        </wrap-container>
      </div>
    </div>
  </div>
</template>

<script>
import WrapContainer from "@/components/core/Container";
import DniTramiteInput from "@/components/core/composite/DniTramiteInput";
import StepNavigator from "@/components/core/StepNavigator";
import FormValidator from "@/components/core/FormValidator";
import { DO_CONSULTAR_RENAPER } from "@/config/constants/action-types";

export default {
  name: "RenaperConsultar",
  components: {
    WrapContainer,
    DniTramiteInput,
    FormValidator,
    StepNavigator
  },
  data() {
    return {
      model: this.$store.getters.getConfirmarRenaper(),
      doNext: DO_CONSULTAR_RENAPER
    };
  },
  computed: {
    canContinue() {
      return this.model.expediente && this.model.expediente.length === 11;
    }
  }
};
</script>

<style scoped>
.images-dni {
  display: flex;
  flex-direction: column;
  align-items: flex-end;
}
.images-dni img {
  display: block;
  margin-bottom: 24px;
  max-width: 265px;
  width: 100%;
  height: auto;
}
.images-dni.mobile {
  display: none;
}
.images-dni.mobile img {
  margin-bottom: 0;
}
.sn-mobile {
  margin-top: 50px;
}

@media screen and (max-width: 600px) {
  .images-dni {
    display: none;
  }
  .images-dni.mobile {
    display: grid !important;
    gap: 10px;
  }
  #titulo {
    font-size: 26px;
  }

  .sn-mobile {
    max-width: 600px;
    width: 100%;
    bottom: 0;
  }
}

@media screen and (min-width: 600px) and (max-width: 1024px) {
  .images-dni {
    display: none;
  }
  .images-dni.mobile {
    display: grid !important;
  }
  .w50 {
    width: 80%;
    max-width: 1024px;
    margin-left: 10%;
    margin-right: 10%;
  }

  .cascade {
    display: block;
  }
}
</style>
